export const auth = {
  // Login page
  "login.title": "Connexion",
  "login.subtitle": "Connectez-vous à votre compte",
  "login.email": "Adresse email",
  "login.password": "Mot de passe",
  "login.remember": "Se souvenir de moi",
  "login.forgot": "Mot de passe oublié ?",
  "login.submit": "Se connecter",
  "login.no_account": "Pas de compte ?",
  "login.register": "Créer un compte",
  "login.welcome": "Bienvenue ! 👋",
  "login.already_signed_in": "Vous êtes déjà connecté.",
  "login.home": "Retour à l'accueil",
  "login.new_to_suji": "Nouveau sur Suji ?",
  "login.create_account_benefits": "Créez un compte pour accéder à des milliers de fournisseurs nigérians vérifiés.",

  // Register page
  "register.title": "Créer votre compte 🚀",
  "register.subtitle": "Rejoignez notre communauté dès aujourd'hui",
  "register.first_name": "Prénom",
  "register.last_name": "Nom",
  "register.email": "Adresse email",
  "register.password": "Mot de passe",
  "register.confirm_password": "Confirmer le mot de passe",
  "register.account_type": "Type de compte",
  "register.customer": "Client",
  "register.supplier": "Fournisseur",
  "register.terms": "J'accepte les conditions d'utilisation",
  "register.submit": "Créer le compte",
  "register.have_account": "Déjà un compte ?",
  "register.login": "Connectez-vous ici",
  "register.already_member": "Déjà membre ?",
  "register.already_signed_in": "Vous êtes déjà connecté.",
  "register.home": "Retour à l'accueil",
  "register.benefit1": "Accès à des milliers de fournisseurs",
  "register.benefit2": "Profils vérifiés et sécurisés",
  "register.benefit3": "Gratuit et sans engagement",

  // Choose role page
  "choose_role.title": "Choisissez votre rôle 🎯",
  "choose_role.subtitle": "Sélectionnez le type de compte qui correspond à vos besoins",
  "choose_role.buyer": "Acheteur",
  "choose_role.buyer_description": "Recherchez et contactez des fournisseurs nigérians vérifiés",
  "choose_role.search": "Recherche avancée",
  "choose_role.direct_contact": "Contact direct",
  "choose_role.certified_profiles": "Profils certifiés",
  "choose_role.supplier": "Fournisseur",
  "choose_role.supplier_description": "Créez votre profil d'entreprise et gérez vos produits",
  "choose_role.business_profile": "Profil entreprise",
  "choose_role.product_management": "Gestion produits",
  "choose_role.dashboard": "Tableau de bord",
  "choose_role.admin": "Administrateur",
  "choose_role.admin_description": "Gérer la plateforme et les catégories",
  "choose_role.user_management": "Gestion utilisateurs",
  "choose_role.category_management": "Gestion catégories",
  "choose_role.moderation": "Modération",
  "choose_role.processing": "Traitement en cours...",
  "choose_role.please_wait": "Veuillez patienter",
  "choose_role.home": "Retour à l'accueil",
  "choose_role.need_help": "Besoin d'aide pour choisir ?",
  "choose_role.help_description": "Choisissez {{buyer}} pour rechercher des fournisseurs, ou {{supplier}} pour promouvoir votre entreprise.",
  "choose_role.admin_not_authorized": "Vous n'êtes pas autorisé à devenir administrateur. Contactez un administrateur existant pour obtenir les droits.",
  "choose_role.error": "Erreur lors de la sélection du rôle",

  // Supplier setup page
  "supplier_setup.title": "Créer votre profil fournisseur 📦",
  "supplier_setup.subtitle": "Complétez les informations de votre entreprise pour commencer",
  "supplier_setup.step": "Étape {{current}} sur {{total}}",
  "supplier_setup.almost_done": "Presque terminé !",
  "supplier_setup.basic_info": "Informations de base",
  "supplier_setup.business_name": "Nom de l'entreprise",
  "supplier_setup.business_name_placeholder": "Ex: ABC Ltd",
  "supplier_setup.category": "Catégorie",
  "supplier_setup.select_category": "Sélectionnez une catégorie",
  "supplier_setup.description": "Description",
  "supplier_setup.description_placeholder": "Décrivez votre entreprise et vos services",
  "supplier_setup.profile_image": "Image de profil",
  "supplier_setup.profile_image_placeholder": "Cliquez pour télécharger ou glisser-déposer",
  "supplier_setup.image_gallery": "Galerie d'images",
  "supplier_setup.image_gallery_placeholder": "Cliquez pour télécharger ou glisser-déposer des images",
  "supplier_setup.business_type": "Type d'activité",
  "supplier_setup.products": "Produits",
  "supplier_setup.services": "Services",
  "supplier_setup.contact_info": "Informations de contact",
  "supplier_setup.phone": "Téléphone",
  "supplier_setup.phone_placeholder": "Numéro de téléphone",
  "supplier_setup.email": "Email",
  "supplier_setup.website": "Site web",
  "supplier_setup.website_placeholder": "https://votre-site.com",
  "supplier_setup.address_info": "Adresse",
  "supplier_setup.address": "Adresse",
  "supplier_setup.address_placeholder": "Adresse complète",
  "supplier_setup.city": "Ville",
  "supplier_setup.city_placeholder": "Nom de la ville",
  "supplier_setup.state": "État",
  "supplier_setup.state_placeholder": "Nom de l'état",
  "supplier_setup.business_hours": "Heures d'ouverture",
  "supplier_setup.days.monday": "Lundi",
  "supplier_setup.days.tuesday": "Mardi",
  "supplier_setup.days.wednesday": "Mercredi",
  "supplier_setup.days.thursday": "Jeudi",
  "supplier_setup.days.friday": "Vendredi",
  "supplier_setup.days.saturday": "Samedi",
  "supplier_setup.days.sunday": "Dimanche",
  "supplier_setup.closed": "Fermé",
  "supplier_setup.cancel": "Annuler",
  "supplier_setup.create_profile": "Créer le profil",
  "supplier_setup.creating_profile": "Création du profil...",
  "supplier_setup.approval_needed": "Merci pour votre inscription ! Votre profil de fournisseur a été soumis et est en attente d'approbation par l'administrateur. Vous recevrez une notification par email une fois approuvé.",
  "supplier_setup.approval_modal.title": "Demande envoyée !",
  "supplier_setup.approval_modal.message": "Votre profil fournisseur a été créé avec succès et est en cours de validation par notre équipe. Vous recevrez une notification par email dès qu'il sera approuvé.",
  "supplier_setup.approval_modal.button": "Retour à l'accueil",
  "supplier_setup.home": "Retour à l'accueil",
  "supplier_setup.errors.business_name_required": "Le nom de l'entreprise est requis",
  "supplier_setup.errors.category_required": "La catégorie est requise",
  "supplier_setup.errors.country_required": "Le pays est requis",
  "supplier_setup.errors.city_required": "La ville est requise",
  "supplier_setup.errors.state_required": "L'état est requis",
  "supplier_setup.errors.email_not_available": "Email non disponible",
  "supplier_setup.errors.profile_creation_error": "Erreur lors de la création du profil fournisseur",
  "supplier_setup.errors.profile_exists": "Un profil fournisseur existe déjà pour cet utilisateur",

  // General
  "loading": "Chargement...",
  "redirecting": "Redirection...",
  "common.error": "Erreur",
  "common.ok": "OK",
  "common.success": "Succès",

  // Validation messages
  "validation.required": "Ce champ est requis",
  "validation.email": "Email invalide",
  "validation.password_min": "Le mot de passe doit contenir au moins 6 caractères",
  "validation.password_match": "Les mots de passe ne correspondent pas",
  "validation.terms": "Vous devez accepter les conditions d'utilisation"
};

export default auth;